// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__lAbBK","additionalInfo":"AgreementModal_additionalInfo__j-fhP"};